import React, { useState } from 'react';
import { IntelyxLogo } from './IntelyxLogo';
import './Header.css';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogoClick = () => {
    // Scroll to the top of the page (hero section)
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleGetStarted = () => {
    // Navigate to contact section
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleSignIn = () => {
    // Determine environment based on hostname
    const hostname = window.location.hostname;
    const isProduction = hostname === 'www.intelyx.ai' || hostname === 'intelyx.ai';
    
    // Use spotton.intelyx.ai for production, app.intelyx.ai for dev/others
    const appUrl = isProduction ? 'https://spotton.intelyx.ai' : 'https://app.intelyx.ai';
    
    window.open(appUrl, '_blank');
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <div className="logo-icon">
            <IntelyxLogo width={48} height={48} />
          </div>
          <span className="logo-text">Intelyx AI</span>
        </div>

        <nav className={`header-nav ${isMenuOpen ? 'open' : ''}`}>
          <a href="#solutions" className="nav-link">Solutions</a>
          <a href="#products" className="nav-link">Products</a>
          <a href="#about" className="nav-link">Company</a>
          <a href="#contact" className="nav-link">Contact Us</a>
        </nav>

        <div className="header-actions">
          <button className="btn-secondary" onClick={handleSignIn}>Sign In</button>
          <button className="btn-primary" onClick={handleGetStarted}>Get Started</button>
        </div>

        <button 
          className="mobile-menu-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};